import { Model } from 'pinia-orm';

export class Goal extends Model {
  static entity = 'goals';
  static primaryKey = 'id';

  static fields() {
    return {
      id: this.uid(),
      experimentId: this.string(''),
      title: this.string(''),
      type: this.string(''),
      input: this.attr(null), // 'selector', 'urls', or null
      countAll: this.boolean(true), // count_all from config
      single: this.boolean(false), // single from config
      isPrimary: this.boolean(false),
      url: this.attr(null), // for goals with input: 'urls'
      selector: this.attr(null), // for goals with input: 'selector'
      createdAt: this.attr(null),
      updatedAt: this.attr(null),
    };
  }

  declare id: string;
  declare experimentId: string;
  declare title: string;
  declare type: string;
  declare input: string | null;
  declare countAll: boolean;
  declare single: boolean;
  declare isPrimary: boolean;
  declare url: string | null;
  declare selector: string | null;
  declare createdAt: string | null;
  declare updatedAt: string | null;

  // Check if this goal is valid (has required field values)
  get isValid(): boolean {
    // Goals without input fields are always valid (like bounce-rate)
    if (!this.input) {
      return true;
    }

    // Goals with input fields need their corresponding field to have a value
    if (this.input === 'selector') {
      return Boolean(this.selector && this.selector.trim().length > 0);
    }

    if (this.input === 'urls') {
      return Boolean(this.url && this.url.trim().length > 0);
    }

    return false;
  }

  // Transform from Goals component format to model format
  static fromGoalsComponent(goalData: any, experimentId: string): any {
    return {
      id: goalData.id,
      experimentId,
      title: goalData.title,
      type: goalData.type,
      input: goalData.input || null,
      countAll: goalData.count_all === 'true',
      single: goalData.single || false,
      isPrimary: goalData.isPrimary,
      url: goalData.url || null,
      selector: goalData.selector || null,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    };
  }
}
